class FsrGiftSystem extends HTMLElement {
  connectedCallback() {
    this._attachSelectors();
    if (!window.giftListenersAttached) {
      this._attachListeners();
      window.giftListenersAttached = true;
    }
    this._updateProgress();
  }

  _attachSelectors() {
    this.progressBarItems = this.querySelectorAll('fsr-gift-system-progress-bar-item');
    this.cartTotalElement = this.querySelector('fsr-gift-system-progress-bar');
  }

  _attachListeners() {
    document.addEventListener('DOMContentLoaded', () => this._updateProgress());
    document.addEventListener('cart:refreshed', () => this._updateProgress());
  }

  _updateProgress() {
    // Retrieve and convert cart total from cents to dollars/euros
    const cartTotalCents = parseFloat(this.cartTotalElement.getAttribute('cart-total')) || 0;
    const cartTotal = cartTotalCents / 100;

    let previousTarget = 0;
    let nextMilestone = null;

    // Iterate over each milestone to calculate and update progress
    this.progressBarItems.forEach(item => {
      const targetCents = parseFloat(item.getAttribute('target')) || 1;
      const target = targetCents / 100;

      // Check if this milestone is free shipping:
      const isFreeShipping = item.dataset.isFreeShipping === 'true';
      // The displayed title could be the product’s title or the free shipping text
      let displayTitle = 'Nächste Belohnung';
      if (isFreeShipping) {
        displayTitle = item.dataset.shippingLabel || 'Kostenloser Versand';
      } else {
        const productTitleElement = item.querySelector('.target-label > div:nth-child(3)');
        if (productTitleElement) {
          displayTitle = productTitleElement.textContent.trim();
        }
      }

      // Calculate progress for this milestone
      let percentage = 0;

      if (cartTotal >= target) {
        percentage = 100;
      } else if (cartTotal > previousTarget) {
        // Current milestone in progress
        percentage = ((cartTotal - previousTarget) / (target - previousTarget)) * 100;
        percentage = Math.min(Math.max(percentage, 0), 100); // Clamp between 0 and 100

        // Retrieve the product title of the current milestone
        const productTitleElement = item.querySelector('.target-label > div:nth-child(3)');
        const productTitle = productTitleElement ? productTitleElement.textContent.trim() : 'Nächste Belohnung';

        nextMilestone = { target, missing: target - cartTotal, productTitle: displayTitle, isFreeShipping: isFreeShipping };
      } else {
        // Milestone not yet started
        percentage = 0;

        if (!nextMilestone) {
          // Retrieve the product title of the next milestone
          const productTitleElement = item.querySelector('.target-label > div:nth-child(3)');
          const productTitle = productTitleElement ? productTitleElement.textContent.trim() : 'Nächste Belohnung';

          nextMilestone = { target, missing: target - cartTotal, productTitle };
        }
      }

      // Update the width of the current-progress bar
      const currentProgress = item.querySelector('.current-progress');
      if (currentProgress) {
        currentProgress.style.width = `${percentage}%`;
      }

      // Select the checkmark and product image elements
      const checkmark = item.querySelector('.gift-added-checkmark');
      const productImage = item.querySelector('.milestone-product-image');

      // Show or hide the checkmark and product image based on milestone achievement
      if (cartTotal >= target) {
        if (checkmark) checkmark.style.display = 'block';
        if (productImage) productImage.style.display = 'none';
      } else {
        if (checkmark) checkmark.style.display = 'none';
        if (productImage) productImage.style.display = 'block';
      }

      previousTarget = target;
    });
    this._updateMissingAmountText(nextMilestone);
  }

  _updateMissingAmountText(milestone) {
    const missingAmountText = this.querySelector('.missing-amount-text');
    if (!missingAmountText) return;

    if (milestone && milestone.missing > 0) {
      const missingFormatted = milestone.missing.toFixed(2).replace('.', ',');

      if (milestone.isFreeShipping) {
        // Next milestone is FREE SHIPPING
        missingAmountText.textContent = `Dir fehlen noch ${missingFormatted}€ bis zum kostenlosen Versand!`;
      } else {
        // Next milestone is a free PRODUCT
        missingAmountText.textContent = `Dir fehlen noch ${missingFormatted}€ bis zu 1x gratis ${milestone.productTitle}`;
      }
    } else {
      // All milestones achieved
      missingAmountText.textContent = 'Herzlichen Glückwunsch! Alle Meilensteine sind erreicht.';
    }
  }

}

customElements.define('fsr-gift-system-main', FsrGiftSystem);
